"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import { flutterStatsData, flutterTechnologiesData } from "src/utils/mock/webAppData";
import { AEOHeroData, aeoAboutData, aeoDevelopSolutionsAndProcessData, aeoFaqData, aeoPortfolioData } from "src/utils/mock/answerEngineOptimizationData";

export default function AnswerEngineOptimization({ caseStudies: apiCaseStudies }) {
  const liveProjects = apiCaseStudies?.projects?.liveProjects || [];

  const activeProjects = liveProjects.filter((project) => {
    return project.projectStatus?.toLowerCase() === "active";
  });

  const filteredData = caseStudies
    ? {
        ...aeoPortfolioData,
        projects: {
          liveProjects: activeProjects,
        },
      }
    : aeoPortfolioData;

  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;

  return (
    <div>
      <AppHero heroData={AEOHeroData} />
      <TechStats stats={flutterStatsData} />

      <WhyChooseUs data={aeoDevelopSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-text-primary px-6! md:px-12! relative overflow-hidden font-sans ">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-500/5 dark:bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-500/5 dark:bg-blue-950/10 blur-[150px] -z-10 rounded-full" />
        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={flutterTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Answer Engine Optimization" sections={aeoAboutData} />
        </div>
      </section>

      <FAQSection faqs={aeoFaqData} />
      <CommonContactSection />
    </div>
  );
}
